module.exports = __webpack_public_path__ + "static/media/kulian.d3c7404b.png";